// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2BGOb","tab":"Tabs_tab__jQAhW","tabActive":"Tabs_tabActive__AAKUS"};